import { defineMessages } from 'react-intl';

export default defineMessages({
  macrocategoryManagedFinancialInsurance: {
    id: 'features.wallet.macrocategoryManagedFinancialInsurance',
    defaultMessage: 'Gestito/Ass.Fin.',
    description: 'Label for the macrocategory Gestito/Assicurativo Finanziario',
  },
  macrocategoryManaged: {
    id: 'features.wallet.macrocategoryManaged',
    defaultMessage: 'Gestito',
    description: 'Label for the macrocategory Gestito',
  },
  macrocategoryFinancialInsurance: {
    id: 'features.wallet.macrocategoryFinancialInsurance',
    defaultMessage: 'Assicurativo fin./assicurativo',
    description: 'Label for the macrocategory Assicurativo Finanziario',
  },

  macrocategoryFinancialInsuranceShort: {
    id: 'features.wallet.macrocategoryFinancialInsuranceShort',
    defaultMessage: 'Ass.Fin/ Ass.',
    description: 'Short label for the macrocategory Assicurativo Finanziario',
  },
  macrocategoryFinancialInsuranceListShort: {
    id: 'features.wallet.macrocategoryFinancialInsuranceListShort',
    defaultMessage: 'Ass.Finanziario/Assicurativo',
    description:
      'Short Label for the macrocategory Assicurativo Finanziario inside the macrocategory list',
  },
  macrocategoryFIA: {
    id: 'features.wallet.macrocategoryFIA',
    defaultMessage: 'Totale FIA',
    description: 'Label for the macrocategory Total FIA',
  },
  macrocategoryRealEconomy: {
    id: 'features.wallet.macrocategoryRealEconomy',
    defaultMessage: 'Economia Reale',
    description: 'Label for the macrocategory Economia Reale',
  },
  macrocategoryRealEconomyShort: {
    id: 'features.wallet.macrocategoryRealEconomyShort',
    defaultMessage: 'Ec.Reale',
    description: 'Short label for the macrocategory Economia Reale',
  },
  macrocategoryTotalFiaShort: {
    id: 'features.wallet.macrocategoryTotalFiaShort',
    defaultMessage: 'FIA',
    description: 'Short label for the macrocategory Total Fia',
  },

  macrocategoryTotalPortfolioShort: {
    id: 'features.wallet.macrocategoryTotalPortfolioShort',
    defaultMessage: 'Tot. Comp. Portafoglio',
    description: 'Short label for the macrocategory Total Portfolio',
  },

  macrocategoryAdministered: {
    id: 'features.wallet.macrocategoryAdministered',
    defaultMessage: 'Amministrato',
    description: 'Label for the macrocategory Amministrato',
  },
  macrocategoryWelfare: {
    id: 'features.wallet.macrocategoryWelfare',
    defaultMessage: 'Previdenza',
    description: 'Label for the macrocategory Previdenza',
  },
  macrocategoryLiquidity: {
    id: 'features.wallet.macrocategoryLiquidity',
    defaultMessage: 'Liquidità',
    description: 'Label for the macrocategory Liquidità',
  },
  macrocategoryTraditionalInsurance: {
    id: 'features.wallet.macrocategoryTraditionalInsurance',
    defaultMessage: 'Assicurativo Tradizionale',
    description: 'Label for the macrocategory Traditional Insurance',
  },
  macrocategoryTotalFia: {
    id: 'features.wallet.macrocategoryTotalFia',
    defaultMessage: 'Versamenti non ancora avvalorati FIA',
    description: 'Label for the macrocategory Total FIA',
  },
  macrocategoryTotalPortfolio: {
    id: 'features.wallet.macrocategoryTotalPortfolio',
    defaultMessage: 'Totale complessivo portafoglio ***',
    description: 'Label for the macrocategory Total FIA',
  },
  macrocategoryTotalPortfolioNoAsterisk: {
    id: 'features.wallet.macrocategoryTotalPortfolio',
    defaultMessage: 'Totale complessivo portafoglio',
    description: 'Label for the macrocategory Total FIA',
  },
  macrocategoryServices: {
    id: 'features.wallet.macrocategoryServices',
    defaultMessage: 'Servizi',
    description: 'Label for the macrocategory Services',
  },
  macrocategoryLiabilities: {
    id: 'features.wallet.macrocategoryLiabilities',
    defaultMessage: 'Passività',
    description: 'Label for the macrocategory Liabilities',
  },
  macrocategoryTraditionalInsuranceShort: {
    id: 'features.wallet.macrocategoryTraditionalInsurance',
    defaultMessage: 'Ass.Trad.',
    description: 'Short label for the macrocategory Assicurativo Tradizionale',
  },
  categoryAssetManagement: {
    id: 'features.wallet.categoryAssetManagement',
    defaultMessage: 'Gestioni patrimoniali mobiliari',
    description: 'Label for the category Asset management',
  },

  categoryBankAccounts: {
    id: 'features.wallet.categoryBankAccounts',
    defaultMessage: 'Conti correnti',
    description: 'Label for the category Conti correnti',
  },

  categoryBonds: {
    id: 'features.wallet.categoryBonds',
    defaultMessage: 'Obbligazioni',
    description: 'Label for the category Obbligazioni',
  },

  categoryBondsAzimut: {
    id: 'features.wallet.categoryBondsAzimut',
    defaultMessage: 'Obbligazioni Azimut',
    description: 'Label for the category Obbligazioni Azimut',
  },

  categoryCertificates: {
    id: 'features.wallet.categoryCertificates',
    defaultMessage: 'Certificates',
    description: 'Label for the category Certificates',
  },

  categoryDifferentValues: {
    id: 'features.wallet.categoryDifferentValues',
    defaultMessage: 'Valori diversi',
    description: 'Label for the category Valori diversi',
  },
  categoryDerivative: {
    id: 'features.wallet.categoryDerivative',
    defaultMessage: 'Derivati',
    description: 'Label for the category Derivati',
  },

  categoryETF: {
    id: 'features.wallet.categoryETF',
    defaultMessage: 'ETF e altri strumenti',
    description: 'Label for the category ETF',
  },

  categoryFundsManagement: {
    id: 'features.wallet.categoryFundsManagement',
    defaultMessage: 'Gestioni patrimoniali in fondi',
    description: 'Label for the category Funds Management',
  },

  categoryHedgeFund: {
    id: 'features.wallet.categoryHedgeFund',
    defaultMessage: 'Fondi Hedge',
    description: 'Label for the category Hedge Fund',
  },

  categoryLiquidAlternative: {
    id: 'features.wallet.categoryLiquidAlternative',
    defaultMessage: 'Alternativi/Multiasset',
    description: 'Label for the category Liquid Alternative',
  },

  categoryMutualFunds: {
    id: 'features.wallet.categoryMutualFunds',
    defaultMessage: 'Fondi comuni di investimento',
    description: 'Label for the category Mutual Funds',
  },

  categoryPensionFund: {
    id: 'features.wallet.categoryPensionFund',
    defaultMessage: 'Fondo pensione',
    description: 'Label for the category Fondo pensione',
  },

  categoryPrivateDebt: {
    id: 'features.wallet.categoryPrivateDebt',
    defaultMessage: 'Private Debt',
    description: 'Label for the categoryPrivate Debt',
  },

  categoryPrivateEquity: {
    id: 'features.wallet.categoryPrivateEquity',
    defaultMessage: 'Private Equity',
    description: 'Label for the category Private Equity',
  },

  categoryRealAsset: {
    id: 'features.wallet.categoryRealAsset',
    defaultMessage: 'Real Asset',
    description: 'Label for the category Real Asset',
  },

  categorySICAV: {
    id: 'features.wallet.categorySICAV',
    defaultMessage: 'SICAV',
    description: 'Label for the category SICAV',
  },

  categoryShares: {
    id: 'features.wallet.categoryShares',
    defaultMessage: 'Azioni',
    description: 'Label for the category Azioni',
  },

  categoryTraditionalLifeInsurance: {
    id: 'features.wallet.categoryTraditionalLifeInsurance',
    defaultMessage: 'Polizze vita tradizionali',
    description: 'Label for the category Polizze vita tradizionali',
  },

  categoryTraditionalPoliciesRevalued: {
    id: 'features.wallet.categoryTraditionalPoliciesRevalued',
    defaultMessage: 'Polizze tradizionali rivalutate',
    description: 'Label for the category Polizze tradizionali rivalutate',
  },

  categoryUnitLinked: {
    id: 'features.wallet.categoryUnitLinked',
    defaultMessage: 'Unit Linked',
    description: 'Label for the category Unit Linked',
  },

  categoryUnitLinkedAtPrice: {
    id: 'features.wallet.categoryUnitLinkedAtPrice',
    defaultMessage: 'Unit Linked a prezzo',
    description: 'Label for the category Unit Linked a prezzo',
  },

  categoryVentureCapital: {
    id: 'features.wallet.categoryVentureCapital',
    defaultMessage: 'Venture Capital',
    description: 'Label for the category Venture Capital',
  },

  quoteEmissione: {
    id: 'features.wallet.quoteEmissione',
    defaultMessage: 'Totale versamenti effettuati per quote in emissione',
    description: 'Label for quote emissione',
  },
  SgrNote: {
    id: 'features.wallet.sgrNote',
    defaultMessage:
      '(1) Il fondo è stato oggetto di fusione \n da parte della SGR',
    description: 'Label for sgr note',
  },
  realeEconomyNote1: {
    id: 'features.wallet.quoteEmissione',
    defaultMessage:
      'I FIA Multirichiamo sono rappresentati all`importo versato fino al completamento del periodo di investimento',
    description: 'Label for Note 1',
  },
  realeEconomyNote2: {
    id: 'features.wallet.quoteEmissione',
    defaultMessage:
      'Per i prodotti FIA per i quali è avvenuto uno stacco provento o rimborso di capitale è stato inserito un NAV provvisorio che tenga conto dell`operazione in attesa del NAV ufficiale.',
    description: 'Label for Note 2',
  },
  commitment: {
    id: 'features.wallet.commitment',
    defaultMessage: 'Commitment',
    description: 'Label for Commitment',
  },
  goToDetail: {
    id: 'features.wallet.goToDetail',
    defaultMessage: 'Vedi dettaglio',
    description: 'Label for cta',
  },
  explain: {
    id: 'features.wallet.explain',
    defaultMessage:
      '2. L’importo rappresentato è in fase di validazione in quanto sono ancora in corso le attività di quadratura da parte della Banca Depositaria',
    description: 'Label for explain',
  },
  bperNote: {
    id: 'features.wallet.bperNote',
    defaultMessage:
      "A seguito dell'integrazione bancaria e dell'allineamento dei sistemi BPER – Pop. Sondrio, il flusso con i saldi bancari verso Azimut non è attivo; le consistenze relative alle posizioni presso BPER sono ferme al 17.04.2026. Per consultare il saldo aggiornato, si invita ad accedere direttamente ai canali informatici di BPER",
    description: 'Label for BPER integration note',
  },
});
